import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, ChevronDownIcon, XIcon } from 'lucide-react';
import { withGps, withoutGps } from '../data/content';
const rows = withoutGps.map((item, index) => ({
  without: item,
  with: withGps[index]
}));
export function Comparison() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-night" data-id="element-39" data-mp="1uxqkou3y90na">
      <div className="mx-auto max-w-content px-6 py-16 lg:py-24" data-id="element-40" data-mp="1uwfhowibvwx8">
        <h2 className="text-center font-display text-3xl font-semibold uppercase tracking-tight text-parchment sm:text-4xl" data-id="element-41" data-mp="1zvsdi6r6geby">
          ⚖️ ¿Cuánto cuesta no tenerlo?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center font-sans text-base text-parchment/60" data-id="element-42" data-mp="28wzzbpcibmp5">
          Tocá cada situación para ver cómo cambia con GPS Bíblico.
        </p>

        <div className="mx-auto mt-10 max-w-3xl space-y-3" data-id="element-43" data-mp="9lyxj2femd26">
          {rows.map((row, index) => {
          const isOpen = openIndex === index;
          return <div key={row.without} className={`overflow-hidden rounded-2xl border transition-colors duration-150 ease-out ${isOpen ? 'border-gold-soft/45 bg-night-panel' : 'border-night-line bg-night-panel/60'}`} data-id="element-44" data-mp="1m1ikthjh8ezs" data-mpi={index}>
                <h3 data-id="element-45" data-mp="187hkwkgsglxu">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-start gap-3 px-5 py-4 text-left transition-colors duration-150 ease-out hover:bg-night-panel focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-soft sm:px-6" data-id="element-46" data-mp="24zbgpzvonono">
                    <XIcon className="mt-0.5 h-5 w-5 flex-none text-rust-soft" aria-hidden="true" data-id="element-47" data-mp="kl1djk0fjmp9" />
                    <span className="flex-1 font-sans text-base font-medium leading-relaxed text-parchment/75" data-id="element-48" data-mp="h2vha5il75xq">
                      {row.without}
                    </span>
                    <ChevronDownIcon aria-hidden="true" className={`mt-0.5 h-5 w-5 flex-none text-gold-soft transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-49" data-mp="81e1ypd078a3" />
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-50" data-mp="33m0p4qgy9t8">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-51" data-mp="3lh1yudthhqxy">
                      <div className="mx-5 mb-5 flex gap-3 rounded-xl border border-gold-soft/30 bg-gold/10 px-5 py-4 sm:mx-6 sm:mb-6" data-id="element-52" data-mp="2wv5mdpwetl4z">
                        <CheckIcon className="mt-0.5 h-5 w-5 flex-none text-gold-soft" aria-hidden="true" data-id="element-53" data-mp="2rx46fdua61xq" />
                        <div data-id="element-54" data-mp="31tz45uiqbyay">
                          <p className="font-sans text-xs font-semibold uppercase tracking-[0.14em] text-gold-soft" data-id="element-55" data-mp="31snpv0rnr85l">
                            Con GPS Bíblico
                          </p>
                          <p className="mt-1 font-sans text-base leading-relaxed text-parchment" data-id="element-56" data-mp="3au5fb9qygm6y">
                            {row.with}
                          </p>
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <p className="mt-10 text-center font-display text-2xl font-semibold italic text-parchment" data-id="element-57" data-mp="3ujftgjb1yz2y">
          La próxima lectura puede ser distinta.
        </p>
      </div>
    </section>;
}